import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { ChatbotComponent } from './chatbot.component';

@NgModule({
  declarations: [ChatbotComponent],
  imports: [
    CommonModule,
    HttpClientModule,
    FormsModule
  ],
  exports: [ChatbotComponent]
})
export class ChatbotModule { } 


// WEBPACK FOOTER //
// /codebuild/output/src2648113480/src/src/app/shared/components/chatbot/chatbot.module.ts